import './src/styles/global.css';

export { wrapPageElement } from './src/wrappers';

// GoatCounter's script counts the first page load by itself. Moving between pages inside the site (like the IS/EN
// switch) doesn't reload the page, so count those here. Jumping to a section (#nu) is not a new page.
export const onRouteUpdate = ({ location, prevLocation }) => {
  if (!prevLocation || prevLocation.pathname === location.pathname) return;
  if (!window.goatcounter || !window.goatcounter.count) return;
  window.goatcounter.count({ path: location.pathname + location.search });
};
